<script lang="ts" setup>
import { getThemeSettings } from '@/lib'
import { resolveLucideIcon } from '@/lib/icon'
import { computed } from 'vue'

interface IconProps {
  variant: string
  strokeWidth?: number
  type?: 'primary' | 'accent' | 'success' | 'info' | 'warning' | 'error'
}

const props = withDefaults(defineProps<IconProps>(), {
  strokeWidth: undefined,
  type: undefined,
})

const { iconWeight } = getThemeSettings()

const effectiveStrokeWidth = computed(() => props.strokeWidth ?? iconWeight ?? 1.75)

const LucideIcon = computed(() => {
  const icon = resolveLucideIcon(props.variant)
  if (!icon) {
    if (props.variant?.trim()) {
      console.warn(`Icon ${props.variant} not found in lucide-vue-next`)
    }
    return null
  }
  return icon
})

const iconClasses = computed(() => ['icon', props.type ? `icon--${props.type}` : null])
</script>

<template>
  <component
    v-if="LucideIcon"
    :is="LucideIcon"
    :size="24"
    :stroke-width="effectiveStrokeWidth"
    :class="iconClasses"
  />
</template>

<style scoped>
.icon--primary {
  color: var(--color-primary);
}
.icon--accent {
  color: var(--color-accent);
}
.icon--success {
  color: var(--color-success);
}
.icon--info {
  color: var(--color-info);
}
.icon--warning {
  color: var(--color-warning);
}
.icon--error {
  color: var(--color-error);
}
</style>
